import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { VerificationTaskService } from '../../../services/verification-task.service';

@Component({
  selector: 'app-verification-task-logs',
  standalone: false,
  templateUrl: './verification-task-logs.component.html'
})
export class VerificationTaskLogsComponent implements OnInit {
  dataLoading = false
  @Input() recordId!: number;
  @Output() close = new EventEmitter<boolean>();
  recordsData: any[] = [];

  constructor(
    private service: VerificationTaskService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true
    this.service.getTaskLogs(this.recordId).subscribe((data) => {
      this.recordsData = data as any[];
      this.dataLoading = false
    }, (error: any) => {

    })
  }
}
